import React from 'react';
import IsConnected from '../../IsConnected/IsConnected'
import DetailsDeletedMember from './SpecificDeletedMember'

class ParselDetailsDeletedMember extends React.Component {

 render() {
   const {...props} = this.props
   return (
     <IsConnected Component={DetailsDeletedMember} {...props}/>
   )
 }
}



export default ParselDetailsDeletedMember;
